import api from "@/services/api";
import type { InsightSummaryResponse } from "../types/insight-summary.types";

export async function getInsightsSummary(): Promise<InsightSummaryResponse> {
	const { data } = await api.get<InsightSummaryResponse>(
		"/api/insight/summary"
	);
	return data;
}
